import { AfterViewChecked, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, take, takeUntil } from 'rxjs';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { PostPartialCJModel } from '../../../shared/models/partial-cj/post-partial-cj';
import { GtmDatalayerUiService } from '../../../shared/service/ui/gtm-datalayer-ui.service';
import { StartUpConfigUiService } from '../../../shared/service/ui/start-up-config-ui.service';
import { SavePartailDetailsComponent } from '../../components/save-partail-details/save-partail-details.component';
import { SectionWiseService } from '../../service/section-wise.service';
import { SwProcessStateService } from '../../service/ui/sw-process-state.service';
import { AbTestConfigModel } from 'src/app/shared/models/start-up-config/abtest-config-model';
import { ApplicationConstant } from 'src/app/application.constant';
import { SwProcessContainerComponent } from '../../components/sw-process-layout/sw-process-container/sw-process-container.component';

@Component({
  selector: 'sw-process, [swProcess]',
  templateUrl: './sw-process.component.html'
})
export class SwProcessComponent implements OnInit, AfterViewChecked, OnDestroy {
  private abTestConfig: AbTestConfigModel = ApplicationConstant.abTestConfig;
  private lastWiseSectionError: string | undefined;
  private initialWiseSectionTracked = false;
  private validationErrors = new Set<string>();
  private destroySubject = new Subject<void>();
  public returnCode: string | null;
  public isPartailsCJ = false;

  @ViewChild('partialInfoSaveModel') partialInfoSaveModel: SavePartailDetailsComponent | undefined;
  @ViewChild(SwProcessContainerComponent) swProcessContainer: SwProcessContainerComponent | undefined;

  constructor(
    private swProcessStateService: SwProcessStateService,
    private startUpConfigUiService: StartUpConfigUiService,
    private gtmDataLayerUiService: GtmDatalayerUiService,
    private sectionWiseService: SectionWiseService
  ) {}

  public ngOnInit() {
    this.swProcessStateService.swContractType$.pipe(takeUntil(this.destroySubject)).subscribe(() => {
      this.validationErrors.clear();
    });
    this.gtmDataLayerUiService.validationError$.pipe(takeUntil(this.destroySubject)).subscribe((questionKey) => {
      this.validationErrors.add(String(questionKey ?? '').toLowerCase());
      if (this.initialWiseSectionTracked) {
        this.trackWiseSection();
      }
    });
    this.swProcessStateService.initSwProcess().subscribe();
    this.swProcessStateService.returnCode$.pipe(take(1)).subscribe(rc => this.returnCode = rc);
    this.startUpConfigUiService.sessionInfo$.pipe(take(1)).subscribe((res) => {
      this.isPartailsCJ = res.isCallCenter;
    });
  }

  public ngAfterViewChecked(): void {
    if (this.initialWiseSectionTracked || !this.swProcessContainer || this.swProcessContainer.isLoading) {
      return;
    }

    this.initialWiseSectionTracked = true;
    this.trackWiseSection();
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  private trackWiseSection(): void {
    const wiseSectionError = this.getWiseSectionError();
    if (wiseSectionError === this.lastWiseSectionError) {
      return;
    }

    this.lastWiseSectionError = wiseSectionError;
    const wiseSectionOrigin = this.returnCode ? 'Recuperar comparativa' : 'Quote Page';
    this.gtmDataLayerUiService.addWiseSectionEvent(wiseSectionError, wiseSectionOrigin).subscribe();
  }

  private getWiseSectionError(): string {
    const sectionsWithError = (this.sectionWiseService.sectionDetailsModel || [])
      .filter((section) => (ApplicationConstant.lookupResourceDetails || []).some((question) =>
        question.SectionName === section.SectionName && (!question.IsValid || this.validationErrors.has(String(question.QuestionNumber ?? '').toLowerCase()))))
      .map((section) => section.Title || section.SectionName);

    return sectionsWithError.length > 0 ? sectionsWithError.join(', ') : '';
  }

  public showPartialCJSaveInfoModal() {
    this.partialInfoSaveModel?.show();
  }

  public savePartailCJContractDetails(partialDetails: any) {
    const request: PostPartialCJModel = {
      operatorId: partialDetails.operator,
      UserTelephoneNumber: partialDetails.telephone,
      partialCJRiskData: new ContractType()
    };

    this.swProcessStateService.savePartailCJContractDetails(request).subscribe((res) => {
      if (this.partialInfoSaveModel && res === true) {
        this.partialInfoSaveModel.isDataSaved = true;
      }
    });
  }

  public getQuotes() {
    this.swProcessStateService.submitSwInput(this.abTestConfig);
  }
}
